<template>
  <div>
    <div class="nav-vertical">
      <ul class="nav nav-tabs nav-left" role="tablist">
        <li class="nav-item">
          <a
            class="nav-link active"
            v-bind:href="'#t1' + rowData.docfisId + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Ocorrências
              <i class="fa fa-file"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t2' + rowData.docfisId + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Documentos
              <i class="fa fa-file-text"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t3' + rowData.docfisId + ''"
            v-if="rowData.cargaDocReentrega != null"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Doc. Saída
              <i class="fa fa-file-text-o"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t4' + rowData.docfisId + ''"
            role="tab"
            v-if="rowData.cargaBipDocMany.length > 0"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Bip Montagem Carga
              <i class="fa fa-barcode"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t5' + rowData.docfisId + ''"
            role="tab"
            v-if="rowData.cargaBipDocMany.length > 0"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Bip Expedição
              <i class="fa fa-barcode"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t7' + rowData.docfisId + ''"
            role="tab"
            data-toggle="tab"
            v-if="
              rowData.cargaDoc != null &&
              rowData.cargaDoc.pedidoUnidadeCargaTrechoDoc[0] != null &&
              rowData.cargaDoc.pedidoUnidadeCargaTrechoDoc[0]
                .pedidoUnidadeCargaTrecho.pedidoUnidadeCargaTrechoAudit !=
                null &&
              rowData.cargaDoc.pedidoUnidadeCargaTrechoDoc[0]
                .pedidoUnidadeCargaTrecho.pedidoUnidadeCargaTrechoAudit
                .auditoriaFrete.docTransp != null
            "
          >
            <span class="nav-link-in">
              Despesa
              <i class="fa fa-money"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t6' + rowData.docfisId + ''"
            role="tab"
            data-toggle="tab"
            v-if="rowData.docTranspDocfis != null"
          >
            <span class="nav-link-in">
              NFe Agregado
              <i class="fa fa-file-archive-o"></i>
            </span>
          </a>
        </li>
      </ul>
      <div class="tab-content">
        <div
          role="tabpanel"
          class="tab-pane fade in active show"
          v-bind:id="'t1' + rowData.docfisId + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 5%">Código</th>
                <th style="width: 15%">Ocorrência</th>
                <th style="width: 10%">Data da Ocorrência</th>
                <th style="width: 10%">Usuario Inc.Ocorrência</th>
                <th style="width: 5%">Status Integração</th>
                <th style="width: 25%">Unidade</th>
                <th style="width: 10%">Doc</th>
                <th style="width: 10%">Carga</th>
                <th style="width: 15%">Obs da carga</th>
                <th style="width: 15%">Ações</th>
                <!-- <th style="width: 10%">Ações</th> -->
              </tr>
            </thead>
            <tbody v-for="item in rowData.cargaOcorrencia">
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ item.paramOcorrenciaResource.cd }}
                </td>
                <td>
                  {{ item.paramOcorrenciaResource.descr }}
                </td>
                <td>
                  {{ formatDate(item.dtOcorrencia) }}
                </td>
                <td>
                  <span v-if="item.usuarioInc.pessoa == null">
                    {{ item.usuarioInc.email }}
                  </span>
                  <span
                    v-if="
                      item.usuarioInc.pessoa != null &&
                      item.usuarioInc.pessoa.pessoaFisica != null
                    "
                  >
                    {{
                      setNomeSobrenome(item.usuarioInc.pessoa.pessoaFisica.nome)
                    }}
                  </span>
                </td>
                <td>
                  <span
                    class="badge badge-success"
                    v-if="item.statusIntegracao.valor == 1"
                    >{{ item.statusIntegracao.descr }}</span
                  >
                  <span
                    class="badge badge-warning"
                    v-if="item.statusIntegracao.valor == 2"
                    >{{ item.statusIntegracao.descr }}</span
                  >
                  <span
                    class="badge badge-danger"
                    v-if="item.statusIntegracao.valor == 3"
                    >{{ item.statusIntegracao.descr }}</span
                  >
                </td>
                <td>
                  <span v-if="item.unidade != null">{{
                    item.unidade.cd + " - " + item.unidade.descr
                  }}</span>
                  <span v-if="item.unidade == null && item.carga != null">{{
                    item.carga.cargaUnidadeCd +
                    " - " +
                    item.carga.cargaUnidadeDescr
                  }}</span>
                </td>
                <td>
                  <!-- <span v-if="item.doc != null && item.carga != null && item.carga.manifesto == null">{{item.doc.numControle}}</span> -->
                  <span
                    v-if="item.doc != null && item.doc.manifestoDoc != null && item.doc.manifestoDoc.manifesto != null"
                    >MDFe : {{ item.doc.manifestoDoc.manifesto.numFiscal }}</span
                  >
                </td>
                <td>
                  <span v-if="item.carga != null && item.carga.tpCrga != 1">{{
                    item.carga.numCarga
                  }}</span> 
                </td>
                <td>
                  <span v-if="item.carga != null && item.carga.obs != null
                  ">
                    {{ item.carga.obs }}
                  </span>
                </td>
                <td>
                  <a
                    @click="onDetail(item.carocorrenId)"
                    v-b-tooltip
                    v-if="item.carga != null"
                    title="Ver detalhes"
                    ><i class="fa fa-plus"></i
                  ></a>
                </td>
              </tr>
              <tr v-if="isVisibleDetail(item.carocorrenId)">
                <td colspan="12">
                  <section class="tabs-section">
                    <ul
                      class="nav nav-tabs nav-topline nav-justified"
                      role="tablist"
                    >
                      <li class="nav-item">
                        <a
                          class="nav-link active"
                          v-bind:href="'#tr1' + item.carocorrenId + ''"
                          role="tab"
                          data-toggle="tab"
                        >
                          <span class="nav-link-in">
                            Detalhes
                            <i class="fa fa-truck"></i>
                          </span>
                        </a>
                      </li>
                      <li class="nav-item">
                        <a
                          v-if="item.cargaOcorrenciaFoto.length > 0"
                          class="nav-link"
                          v-bind:href="'#tr2' + item.carocorrenId + ''"
                          role="tab"
                          data-toggle="tab"
                        >
                          <span class="nav-link-in">
                            Fotos
                            <i class="fa fa-picture-o"></i>
                          </span>
                        </a>
                      </li>
                    </ul>
                    <div class="tab-content">
                      <div
                        role="tabpanel"
                        class="tab-pane fade in active show pt-1 border-color-detalhes-grey"
                        v-bind:id="'tr1' + item.carocorrenId + ''"
                      >
                        <table
                          :class="['vuetable table table-striped tbl-typical']"
                        >
                          <thead>
                            <tr>
                              <th style="width: 5%">N° Carga</th>
                              <th style="width: 10%">Unidade</th>
                              <th style="width: 30%">Parceiro/Redespacho</th>
                              <th style="width: 20%">Motorista</th>
                              <th style="width: 10%">Placa principal</th>
                              <th style="width: 30%">Transportadora</th>
                              <th style="width: 5%">Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              class="bg-gray-light"
                              style="display: table-row"
                            >
                              <td>
                                {{ item.carga.numCarga }}
                              </td>
                              <td>
                                {{ item.carga.cargaUnidadeCd }}
                              </td>
                              <td>
                                <span v-if="item.carga.pessoaParceira != null">
                                  Parceiro:
                                  {{
                                    item.carga.pessoaParceira.pessoaJuridica
                                      .razaoSocial
                                  }}
                                </span>
                                <span
                                  v-if="
                                    rowData.docFiscalPartesEnv
                                      .redCnpj != null
                                  "
                                >
                                  Red :
                                  {{
                                    rowData.docFiscalPartesEnv
                                      .redNome
                                  }}
                                  - CNPJ:
                                  {{
                                    rowData.docFiscalPartesEnv
                                      .redCnpj
                                  }}
                                </span>
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.carga.cargaMeioTransp.nomeMotorista !=
                                    null
                                  "
                                  >{{
                                    setNomeSobrenome(
                                      item.carga.cargaMeioTransp.nomeMotorista
                                    )
                                  }}</span
                                >
                                <span
                                  v-if="
                                    item.carga.cargaMeioTranspManual != null
                                  "
                                  >{{
                                    setNomeSobrenome(
                                      item.carga.cargaMeioTranspManual.nome
                                    )
                                  }}</span
                                >
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.carga.cargaMeioTransp
                                      .meioTransportePrimarioPlaca != null
                                  "
                                  >{{
                                    item.carga.cargaMeioTransp
                                      .meioTransportePrimarioPlaca
                                  }}</span
                                >
                                <span
                                  v-if="
                                    item.carga.cargaMeioTranspManual != null
                                  "
                                  >{{
                                    item.carga.cargaMeioTranspManual
                                      .placaPrimaria
                                  }}</span
                                >
                              </td>
                              <td>
                                <span v-if="item.carga.pessoa != null">{{
                                  item.carga.pessoa.pessoaJuridica.razaoSocial
                                }}</span>
                              </td>
                              <td>
                                <span
                                  class="badge badge-info"
                                  v-if="item.carga.status.valor == 6"
                                  >{{ item.carga.status.descr }}</span
                                >
                                <span
                                  class="badge badge-success"
                                  v-if="item.carga.status.valor == 3"
                                  >{{ item.carga.status.descr }}</span
                                >
                                <span
                                  class="badge badge-warning"
                                  v-if="item.carga.status.valor == 2"
                                  >{{ item.carga.status.descr }}</span
                                >
                                <span
                                  class="badge badge-warning"
                                  v-if="item.carga.status.valor == 1"
                                  >{{ item.carga.status.descr }}</span
                                >
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <div
                        role="tabpanel"
                        class="tab-pane fade in pt-1 border-color-detalhes-grey"
                        v-bind:id="'tr2' + item.carocorrenId + ''"
                      >
                        <table
                          :class="['vuetable table table-striped tbl-typical']"
                        >
                          <thead>
                            <tr>
                              <th style="width: 10%">N° da foto</th>
                              <th style="width: 35%">Link</th>
                            </tr>
                          </thead>
                          <tbody
                            v-for="(item_itens, i) in item.cargaOcorrenciaFoto"
                          >
                            <tr
                              class="bg-gray-light"
                              style="display: table-row"
                            >
                              <td>
                                {{ i + 1 }}
                              </td>
                              <td>
                                <a
                                  @click="goLink(item_itens.urlFoto)"
                                  target="_blank"
                                  >{{ item_itens.nomeFoto }}</a
                                >
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </section>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade"
          v-bind:id="'t2' + rowData.docfisId + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 5%">N° Doc</th>
                <th style="width: 10%">Dt Emissão Doc</th>
                <th style="width: 5%">Valor Doc</th>
                <th style="width: 5%">Peso Bruto</th>
                <th style="width: 10%">Processo</th>
                <th style="width: 10%">Operação</th>
                <th style="width: 10%">N° carga tracking</th>
                <th style="width: 10%">Usuario Emissor</th>
                <th style="width: 5%">Qtd. de notas</th>
                <th style="width: 15%">Região</th>
                <th style="width: 5%">Status</th>
                <th style="width: 5%">Ações</th>
              </tr>
            </thead>
            <tbody v-for="item in rowData.cargaDocReentrega">
              <tr v-if="item.docCargaDoc" class="bg-gray-light" style="display: table-row">
                <td>
                  {{ item.docCargaDoc ? item.docCargaDoc.doc.numFiscal : '' }}
                </td>
                <td>
                  {{ item.docCargaDoc ? formatDate(item.docCargaDoc.doc.dtEmi) : '' }}
                </td>
                <td><span v-if="item.docCargaDoc">R$ {{ formatNumber(item.docCargaDoc.doc.vlrReceber) }}</span></td>
                <td>
                  <span v-if="item.docCargaDoc.doc.docCte != null"
                    >{{
                      formatNumber(
                        item.docCargaDoc.doc.docCte.docCteCarga[0].qtd
                      )
                    }}
                    {{
                      item.docCargaDoc.doc.docCte.docCteCarga[0]
                        .paramUnidadeMedida.descr
                    }}</span
                  >
                </td>
                <td>
                  {{ item.docCargaDoc.doc.tpProcesso.descr }}
                </td>
                <td>
                  {{ item.docCargaDoc.doc.tpOperacao.descr }}
                </td>
                <td>
                  <span
                    v-if="showMdfe(item)"
                  >
                    {{ item.docCargaDoc.doc.manifestoDoc.manifesto.numCargaItrack }}
                  </span>
                  <span
                    v-if="
                      rowData.docFiscalTracking != null &&
                      (
                        item.docCargaDoc == null ||
                        item.docCargaDoc.doc == null ||
                        item.docCargaDoc.doc.manifestoDoc == null ||
                        item.docCargaDoc.doc.manifestoDoc.manifesto == null
                      )
                    "
                  >
                    {{ rowData.docFiscalTracking }}
                  </span>
                </td>
                <td>
                  <span v-if="item.docCargaDoc.doc.usuarioInc.pessoa != null">
                    {{
                      setNomeSobrenome(
                        item.docCargaDoc.doc.usuarioInc.pessoa.pessoaFisica.nome
                      )
                    }}
                  </span>
                  <span v-if="item.docCargaDoc.doc.usuarioInc.pessoa == null">
                    {{ item.docCargaDoc.doc.usuarioInc.email }}
                  </span>
                </td>
                <td>
                  {{ rowData.qtdTotalNotasCte }}
                </td>
                <td>
                  <span
                    v-if="item != null && item.docCargaDoc.doc.tpDoc.valor == 2"
                  >
                    {{ item.docCargaDoc.doc.docRps.docRpsRegiao }}
                  </span>
                  <span
                    v-if="
                      item != null &&
                      item.docCargaDoc.doc.tpDoc.valor == 1 &&
                      item.docCargaDoc.doc.regiaoDespesa != null
                    "
                  >
                    {{
                      item.docCargaDoc.doc.regiaoDespesa.cd +
                      " - " +
                      item.docCargaDoc.doc.regiaoDespesa.descr
                    }}
                  </span>
                </td>
                <td>
                  <span
                    class="badge badge-danger"
                    v-if="
                      item.docCargaDoc.doc.tpDoc.valor == 1 &&
                      item.docCargaDoc.doc.docCte.statusSefaz.valor == 1
                    "
                    >{{ item.docCargaDoc.doc.docCte.statusSefaz.descr }}</span
                  >
                  <span
                    class="badge badge-warning"
                    v-if="
                      item.docCargaDoc.doc.tpDoc.valor == 1 &&
                      item.docCargaDoc.doc.docCte.statusSefaz.valor == 2
                    "
                    >{{ item.docCargaDoc.doc.docCte.statusSefaz.descr }}</span
                  >
                  <span
                    class="badge badge-info"
                    v-if="
                      item.docCargaDoc.doc.tpDoc.valor == 1 &&
                      item.docCargaDoc.doc.docCte.statusSefaz.valor == 3
                    "
                    >{{ item.docCargaDoc.doc.docCte.statusSefaz.descr }}</span
                  >
                  <span
                    class="badge badge-success"
                    v-if="
                      item.docCargaDoc.doc.tpDoc.valor == 1 &&
                      item.docCargaDoc.doc.docCte.statusSefaz.valor == 4
                    "
                    >{{ item.docCargaDoc.doc.docCte.statusSefaz.descr }}</span
                  >
                  <span
                    class="badge badge-success"
                    v-if="
                      item.docCargaDoc.doc.tpDoc.valor == 1 &&
                      item.docCargaDoc.doc.docCte.statusSefaz.valor == 6
                    "
                    >{{ item.docCargaDoc.doc.docCte.statusSefaz.descr }}</span
                  >
                  <span
                    class="badge badge-success"
                    v-if="
                      item.docCargaDoc.doc.tpDoc.valor == 1 &&
                      item.docCargaDoc.doc.docCte.statusSefaz.valor == 8
                    "
                    >{{ item.docCargaDoc.doc.docCte.statusSefaz.descr }}</span
                  >
                  <span
                    class="badge badge-info"
                    v-if="
                      item.docCargaDoc.doc.tpDoc.valor == 1 &&
                      item.docCargaDoc.doc.docCte.statusSefaz.valor == 5
                    "
                    >{{ item.docCargaDoc.doc.docCte.statusSefaz.descr }}</span
                  >
                  <span
                    class="badge badge-danger"
                    v-if="
                      item.docCargaDoc.doc.tpDoc.valor == 1 &&
                      item.docCargaDoc.doc.docCte.statusSefaz.valor == 7
                    "
                    >{{ item.docCargaDoc.doc.docCte.statusSefaz.descr }}</span
                  >
                </td>
                <td>
                  <a
                    @click="onDetail(item.docCargaDoc.docId)"
                    v-b-tooltip
                    title="Ver Detalhes"
                    ><i class="fa fa-plus"></i
                  ></a>
                  <span
                    v-if="
                      item.docCargaDoc.doc.tpDoc.valor == 1 &&
                      item.docCargaDoc.doc.docCte.statusSefaz.valor == 4
                    "
                  >
                    <a
                      @click="
                        onImprimirXml(
                          item.docCargaDoc.doc.docId,
                          1,
                          item.docCargaDoc.doc.tpDoc.valor
                        )
                      "
                      v-if="item.docCargaDoc.doc.docCte.docCteXml.length > 0"
                      v-b-tooltip
                      title="Imprimir Dacte"
                    >
                      <i class="fa fa-download"></i>
                    </a>
                  </span>
                  <span v-if="getPermission('cte.imprimir')">
                    <span
                      v-if="
                        item.docCargaDoc.doc.tpDoc.valor == 1 &&
                        (item.docCargaDoc.doc.docCte.statusSefaz.valor == 4 ||
                          item.docCargaDoc.doc.docCte.statusSefaz.valor == 7)
                      "
                    >
                      <a
                        @click="
                          onDownloadXml(
                            item.docCargaDoc.doc.docCte.doccteId,
                            null
                          )
                        "
                        v-if="
                          (item.docCargaDoc.doc.docCte != null &&
                            item.docCargaDoc.doc.docCte.docCteXml.length > 0) ||
                          item.docCargaDoc.doc.docCte.docCteXml.length > 0
                        "
                        v-b-tooltip
                        title="Download XML"
                        ><i class="fa fa-code"></i
                      ></a>
                    </span>
                  </span>
                  <div v-if="item.docCargaDoc.doc.tpDoc.valor == 2">
                    <span v-if="getPermission('cte.imprimir')">
                      <span>
                        <a
                          @click="
                            onDownloadXml(
                              null,
                              item.docCargaDoc.doc.docRps.docrpsId
                            )
                          "
                          v-if="
                            item.docCargaDoc.doc.docRps.docRpsXml.length > 0
                          "
                          v-b-tooltip
                          title="Download XML"
                          ><i class="fa fa-code"></i
                        ></a>
                      </span>
                    </span>
                  </div>
                  <span v-if="rowData.cargaDoc.docCargaDoc">
                    <span>
                      <a
                        @click="
                          onImprimirRps(
                            item.docCargaDoc.doc.docId,
                            item.docCargaDoc.doc.tpDoc.valor
                          )
                        "
                        v-if="rowData.cargaDoc.docCargaDoc.doc.docRps != null"
                        v-b-tooltip
                        title="Imprimir RPS"
                        ><i class="fa fa-download"></i
                      ></a>
                    </span>
                  </span>
                </td>
              </tr>
              <tr v-if="item.docCargaDoc && isVisibleDetail(item.docCargaDoc.docId)">
                <td colspan="12">
                  <section class="tabs-section">
                    <ul
                      class="nav nav-tabs nav-topline nav-justified"
                      role="tablist"
                    >
                      <li class="nav-item">
                        <a
                          class="nav-link active"
                          v-bind:href="'#tr3' + item.docCargaDoc.docId + ''"
                          role="tab"
                          data-toggle="tab"
                        >
                          <span class="nav-link-in">
                            Partes Env.
                            <i class="fa fa-users"></i>
                          </span>
                        </a>
                      </li>
                      <li class="nav-item">
                        <a
                          class="nav-link"
                          v-bind:href="'#tr2' + item.docCargaDoc.docId + ''"
                          role="tab"
                          data-toggle="tab"
                        >
                          <span class="nav-link-in">
                            Calculo - Tabela Receita
                            <i class="fa fa-file-excel-o"></i>
                          </span>
                        </a>
                      </li>
                    </ul>
                    <div class="tab-content">
                      <div
                        role="tabpanel"
                        class="tab-pane fade in active show pt-1 border-color-detalhes-grey"
                        v-bind:id="'tr3' + item.docCargaDoc.docId + ''"
                      >
                        <table
                          :class="['vuetable table table-striped tbl-typical']"
                        >
                          <thead>
                            <tr>
                              <th data-toggle="true" style="width: 10%"></th>
                              <th data-toggle="true" style="width: 10%">
                                CNPJ / CPF
                              </th>
                              <th data-toggle="true" style="width: 10%">IE</th>
                              <th data-toggle="true" style="width: 10%">
                                Nome
                              </th>
                              <th data-toggle="true" style="width: 10%">
                                Município
                              </th>
                              <th data-toggle="true" style="width: 3%">
                                Estado
                              </th>
                              <th data-toggle="true" style="width: 15%">
                                Endereço
                              </th>
                              <th data-toggle="true" style="width: 12%">
                                Bairro
                              </th>
                              <th data-toggle="true" style="width: 10%">CEP</th>
                              <th data-toggle="true" style="width: 10%">
                                Email
                              </th>
                              <th data-toggle="true" style="width: 5%">
                                Telefone
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              class="bg-gray-light"
                              style="display: table-row"
                              v-if="
                                item.docCargaDoc.doc.docCtePartesEnv.emiEndereco
                              "
                            >
                              <td>
                                <span class="badge badge-primary"
                                  >Emitente</span
                                >
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .eminpj != null
                                  "
                                >
                                  {{
                                    ajustaMascara(
                                      item.docCargaDoc.doc.docCtePartesEnv
                                        .emiCnpj
                                    )
                                  }}
                                </span>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .emiCpf != null
                                  "
                                >
                                  {{
                                    ajustaMascara(
                                      item.docCargaDoc.doc.docCtePartesEnv
                                        .emiCpf
                                    )
                                  }}
                                </span>
                              </td>
                              <td>
                                {{ item.docCargaDoc.doc.docCtePartesEnv.emiIe }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv.emiNome
                                }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv
                                    .emiNomeMunicipio
                                }}
                              </td>
                              <td>
                                {{ item.docCargaDoc.doc.docCtePartesEnv.emiUf }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv
                                    .emiEndereco
                                }}
                                -
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv
                                    .emiComplemento
                                }}
                                -
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv.emiNumero
                                }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv.emiBairro
                                }}
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv.emiCep
                                  "
                                  >{{
                                    item.docCargaDoc.doc.docCtePartesEnv.emiCep
                                      .toString()
                                      .padStart(8, "0")
                                  }}</span
                                >
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .emiEmail
                                  "
                                  >{{
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .emiEmail
                                  }}</span
                                >
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .emiTelefone
                                  "
                                  >{{
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .emiTelefone
                                  }}</span
                                >
                              </td>
                            </tr>
                          </tbody>
                          <tbody>
                            <tr
                              class="bg-gray-light"
                              style="display: table-row"
                              v-if="
                                item.docCargaDoc.doc.docCtePartesEnv.remEndereco
                              "
                            >
                              <td>
                                <span class="badge badge-warning"
                                  >Remetente</span
                                >
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .remCnpj != null
                                  "
                                >
                                  {{
                                    ajustaMascara(
                                      item.docCargaDoc.doc.docCtePartesEnv
                                        .remCnpj
                                    )
                                  }}
                                </span>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .remCpf != null
                                  "
                                >
                                  {{
                                    ajustaMascara(
                                      item.docCargaDoc.doc.docCtePartesEnv
                                        .remCpf
                                    )
                                  }}
                                </span>
                              </td>
                              <td>
                                {{ item.docCargaDoc.doc.docCtePartesEnv.remIe }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv.remNome
                                }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv
                                    .remNomeMunicipio
                                }}
                              </td>
                              <td>
                                {{ item.docCargaDoc.doc.docCtePartesEnv.remUf }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv
                                    .remEndereco
                                }}
                                -
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv
                                    .remComplemento
                                }}
                                -
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv.remNumero
                                }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv.remBairro
                                }}
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv.remCep
                                  "
                                  >{{
                                    item.docCargaDoc.doc.docCtePartesEnv.remCep
                                      .toString()
                                      .padStart(8, "0")
                                  }}</span
                                >
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .remEmail
                                  "
                                  >{{
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .remEmail
                                  }}</span
                                >
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .remTelefone
                                  "
                                  >{{
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .remTelefone
                                  }}</span
                                >
                              </td>
                            </tr>
                          </tbody>
                          <tbody>
                            <tr
                              class="bg-gray-light"
                              style="display: table-row"
                              v-if="
                                item.docCargaDoc.doc.docCtePartesEnv.expEndereco
                              "
                            >
                              <td>
                                <span class="badge badge-info">Expedidor</span>
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .expCnpj != null
                                  "
                                >
                                  {{
                                    ajustaMascara(
                                      item.docCargaDoc.doc.docCtePartesEnv
                                        .expCnpj
                                    )
                                  }}
                                </span>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .expCpf != null
                                  "
                                >
                                  {{
                                    ajustaMascara(
                                      item.docCargaDoc.doc.docCtePartesEnv
                                        .expCpf
                                    )
                                  }}
                                </span>
                              </td>
                              <td>
                                {{ item.docCargaDoc.doc.docCtePartesEnv.expIe }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv.expNome
                                }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv
                                    .expNomeMunicipio
                                }}
                              </td>
                              <td>
                                {{ item.docCargaDoc.doc.docCtePartesEnv.expUf }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv
                                    .expEndereco
                                }}
                                -
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv
                                    .expComplemento
                                }}
                                -
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv.expNumero
                                }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv.expBairro
                                }}
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv.expCep
                                  "
                                  >{{
                                    item.docCargaDoc.doc.docCtePartesEnv.expCep
                                      .toString()
                                      .padStart(8, "0")
                                  }}</span
                                >
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .expEmail
                                  "
                                  >{{
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .expEmail
                                  }}</span
                                >
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .expTelefone
                                  "
                                  >{{
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .expTelefone
                                  }}</span
                                >
                              </td>
                            </tr>
                          </tbody>
                          <tbody>
                            <tr
                              class="bg-gray-light"
                              style="display: table-row"
                              v-if="
                                item.docCargaDoc.doc.docCtePartesEnv.desEndereco
                              "
                            >
                              <td>
                                <span class="badge badge-success"
                                  >Destinatário</span
                                >
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .desCnpj != null
                                  "
                                >
                                  {{
                                    ajustaMascara(
                                      item.docCargaDoc.doc.docCtePartesEnv
                                        .desCnpj
                                    )
                                  }}
                                </span>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .desCpf != null
                                  "
                                >
                                  {{
                                    ajustaMascara(
                                      item.docCargaDoc.doc.docCtePartesEnv
                                        .desCpf
                                    )
                                  }}
                                </span>
                              </td>
                              <td>
                                {{ item.docCargaDoc.doc.docCtePartesEnv.desIe }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv.desNome
                                }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv
                                    .desNomeMunicipio
                                }}
                              </td>
                              <td>
                                {{ item.docCargaDoc.doc.docCtePartesEnv.desUf }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv
                                    .desEndereco
                                }}
                                -
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv
                                    .desComplemento
                                }}
                                -
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv.desNumero
                                }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv.desBairro
                                }}
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv.desCep
                                  "
                                  >{{
                                    item.docCargaDoc.doc.docCtePartesEnv.desCep
                                      .toString()
                                      .padStart(8, "0")
                                  }}</span
                                >
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .desEmail
                                  "
                                  >{{
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .desEmail
                                  }}</span
                                >
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .desTelefone
                                  "
                                  >{{
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .desTelefone
                                  }}</span
                                >
                              </td>
                            </tr>
                          </tbody>
                          <tbody>
                            <tr
                              class="bg-gray-light"
                              style="display: table-row"
                              v-if="
                                item.docCargaDoc.doc.docCtePartesEnv.recEndereco
                              "
                            >
                              <td>
                                <span class="badge badge-secondary"
                                  >Recebedor</span
                                >
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .recCnpj != null
                                  "
                                >
                                  {{
                                    ajustaMascara(
                                      item.docCargaDoc.doc.docCtePartesEnv
                                        .recCnpj
                                    )
                                  }}
                                </span>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .recCpf != null
                                  "
                                >
                                  {{
                                    ajustaMascara(
                                      item.docCargaDoc.doc.docCtePartesEnv
                                        .recCpf
                                    )
                                  }}
                                </span>
                              </td>
                              <td>
                                {{ item.docCargaDoc.doc.docCtePartesEnv.recIe }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv.recNome
                                }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv
                                    .recNomeMunicipio
                                }}
                              </td>
                              <td>
                                {{ item.docCargaDoc.doc.docCtePartesEnv.recUf }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv
                                    .recEndereco
                                }}
                                -
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv
                                    .recComplemento
                                }}
                                -
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv.recNumero
                                }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv.recBairro
                                }}
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv.recCep
                                  "
                                  >{{
                                    item.docCargaDoc.doc.docCtePartesEnv.recCep
                                      .toString()
                                      .padStart(8, "0")
                                  }}</span
                                >
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .recEmail
                                  "
                                  >{{
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .recEmail
                                  }}</span
                                >
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .recTelefone
                                  "
                                  >{{
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .recTelefone
                                  }}</span
                                >
                              </td>
                            </tr>
                          </tbody>
                          <tbody>
                            <tr
                              class="bg-gray-light"
                              style="display: table-row"
                              v-if="
                                item.docCargaDoc.doc.docCtePartesEnv.tomEndereco
                              "
                            >
                              <td>
                                <span class="badge badge-primary">Tomador</span>
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .tomCnpj != null
                                  "
                                >
                                  {{
                                    ajustaMascara(
                                      item.docCargaDoc.doc.docCtePartesEnv
                                        .tomCnpj
                                    )
                                  }}
                                </span>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .tomCpf != null
                                  "
                                >
                                  {{
                                    ajustaMascara(
                                      item.docCargaDoc.doc.docCtePartesEnv
                                        .tomCpf
                                    )
                                  }}
                                </span>
                              </td>
                              <td>
                                {{ item.docCargaDoc.doc.docCtePartesEnv.tomIe }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv.tomNome
                                }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv
                                    .tomNomeMunicipio
                                }}
                              </td>
                              <td>
                                {{ item.docCargaDoc.doc.docCtePartesEnv.tomUf }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv
                                    .tomEndereco
                                }}
                                -
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv
                                    .tomComplemento
                                }}
                                -
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv.tomNumero
                                }}
                              </td>
                              <td>
                                {{
                                  item.docCargaDoc.doc.docCtePartesEnv.tomBairro
                                }}
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv.tomCep
                                  "
                                  >{{
                                    item.docCargaDoc.doc.docCtePartesEnv.tomCep
                                      .toString()
                                      .padStart(8, "0")
                                  }}</span
                                >
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .tomEmail
                                  "
                                  >{{
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .tomEmail
                                  }}</span
                                >
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .tomTelefone
                                  "
                                  >{{
                                    item.docCargaDoc.doc.docCtePartesEnv
                                      .tomTelefone
                                  }}</span
                                >
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <!--.tab-pane-->
                      <div
                        role="tabpanel"
                        class="tab-pane fade in pt-1 border-color-detalhes-grey"
                        v-bind:id="'tr2' + item.docCargaDoc.docId + ''"
                      >
                        <b-tabs>
                          <b-tab title="Rota" active>
                            <b-row
                              class="p-a-0"
                              id="row"
                              style="margin-top: 10px"
                            >
                              <b-col md="3">
                                <label>Municipio de Origem: </label>
                                <span
                                  v-if="
                                    item.docCargaDoc.cargaDoc
                                      .cargaDocUnidadeCarga[0]
                                      .pedidoUnidadeCarga
                                      .pedidoUnidadeCargaTrecho[0]
                                      .tabelaFreteRotaVig.tabelaFreteRota
                                      .municipioOrigem != null
                                  "
                                >
                                  {{
                                    item.docCargaDoc.cargaDoc
                                      .cargaDocUnidadeCarga[0]
                                      .pedidoUnidadeCarga
                                      .pedidoUnidadeCargaTrecho[0]
                                      .tabelaFreteRotaVig.tabelaFreteRota
                                      .municipioOrigem.nome
                                  }}
                                  -
                                  {{
                                    item.docCargaDoc.cargaDoc
                                      .cargaDocUnidadeCarga[0]
                                      .pedidoUnidadeCarga
                                      .pedidoUnidadeCargaTrecho[0]
                                      .tabelaFreteRotaVig.tabelaFreteRota
                                      .municipioOrigem.uf.cd
                                  }}</span
                                >
                                <span
                                  v-if="
                                    item.docCargaDoc.cargaDoc
                                      .cargaDocUnidadeCarga[0]
                                      .pedidoUnidadeCarga
                                      .pedidoUnidadeCargaTrecho[0]
                                      .tabelaFreteRotaVig.tabelaFreteRota
                                      .municipioOrigem == null
                                  "
                                >
                                  Não constado</span
                                >
                              </b-col>
                              <b-col md="3">
                                <label>Municipio de Destino: </label>
                                <span
                                  v-if="
                                    item.docCargaDoc.cargaDoc
                                      .cargaDocUnidadeCarga[0]
                                      .pedidoUnidadeCarga
                                      .pedidoUnidadeCargaTrecho[0]
                                      .tabelaFreteRotaVig.tabelaFreteRota
                                      .municipioDestino != null
                                  "
                                >
                                  {{
                                    item.docCargaDoc.cargaDoc
                                      .cargaDocUnidadeCarga[0]
                                      .pedidoUnidadeCarga
                                      .pedidoUnidadeCargaTrecho[0]
                                      .tabelaFreteRotaVig.tabelaFreteRota
                                      .municipioDestino.nome
                                  }}
                                  -
                                  {{
                                    item.docCargaDoc.cargaDoc
                                      .cargaDocUnidadeCarga[0]
                                      .pedidoUnidadeCarga
                                      .pedidoUnidadeCargaTrecho[0]
                                      .tabelaFreteRotaVig.tabelaFreteRota
                                      .municipioDestino.uf.cd
                                  }}</span
                                >
                                <span
                                  v-if="
                                    item.docCargaDoc.cargaDoc
                                      .cargaDocUnidadeCarga[0]
                                      .pedidoUnidadeCarga
                                      .pedidoUnidadeCargaTrecho[0]
                                      .tabelaFreteRotaVig.tabelaFreteRota
                                      .municipioDestino == null
                                  "
                                >
                                  Não constado</span
                                >
                              </b-col>
                              <b-col md="3">
                                <label>Região de Origem: </label>
                                <span
                                  v-if="
                                    item.docCargaDoc.cargaDoc
                                      .cargaDocUnidadeCarga[0]
                                      .pedidoUnidadeCarga
                                      .pedidoUnidadeCargaTrecho[0]
                                      .tabelaFreteRotaVig.tabelaFreteRota
                                      .regiaoOrigem != null
                                  "
                                >
                                  {{
                                    item.docCargaDoc.cargaDoc
                                      .cargaDocUnidadeCarga[0]
                                      .pedidoUnidadeCarga
                                      .pedidoUnidadeCargaTrecho[0]
                                      .tabelaFreteRotaVig.tabelaFreteRota
                                      .regiaoOrigem.cd
                                  }}
                                  -
                                  {{
                                    item.docCargaDoc.cargaDoc
                                      .cargaDocUnidadeCarga[0]
                                      .pedidoUnidadeCarga
                                      .pedidoUnidadeCargaTrecho[0]
                                      .tabelaFreteRotaVig.tabelaFreteRota
                                      .regiaoOrigem.descr
                                  }}</span
                                >
                                <span
                                  v-if="
                                    item.docCargaDoc.cargaDoc
                                      .cargaDocUnidadeCarga[0]
                                      .pedidoUnidadeCarga
                                      .pedidoUnidadeCargaTrecho[0]
                                      .tabelaFreteRotaVig.tabelaFreteRota
                                      .regiaoOrigem == null
                                  "
                                >
                                  Não constado</span
                                >
                              </b-col>
                              <b-col md="3">
                                <label>Região de Destino: </label>
                                <span
                                  v-if="
                                    item.docCargaDoc.cargaDoc
                                      .cargaDocUnidadeCarga[0]
                                      .pedidoUnidadeCarga
                                      .pedidoUnidadeCargaTrecho[0]
                                      .tabelaFreteRotaVig.tabelaFreteRota
                                      .regiaoDestino != null
                                  "
                                >
                                  {{
                                    item.docCargaDoc.cargaDoc
                                      .cargaDocUnidadeCarga[0]
                                      .pedidoUnidadeCarga
                                      .pedidoUnidadeCargaTrecho[0]
                                      .tabelaFreteRotaVig.tabelaFreteRota
                                      .regiaoDestino.cd
                                  }}
                                  -
                                  {{
                                    item.docCargaDoc.cargaDoc
                                      .cargaDocUnidadeCarga[0]
                                      .pedidoUnidadeCarga
                                      .pedidoUnidadeCargaTrecho[0]
                                      .tabelaFreteRotaVig.tabelaFreteRota
                                      .regiaoDestino.descr
                                  }}
                                </span>
                                <span
                                  v-if="
                                    item.docCargaDoc.cargaDoc
                                      .cargaDocUnidadeCarga[0]
                                      .pedidoUnidadeCarga
                                      .pedidoUnidadeCargaTrecho[0]
                                      .tabelaFreteRotaVig.tabelaFreteRota
                                      .regiaoDestino == null
                                  "
                                >
                                  Não constado</span
                                >
                              </b-col>
                            </b-row>
                            <b-row class="p-a-0">
                              <b-col>
                                <label><strong>Tabela de frete:</strong></label>
                                <span>
                                  {{
                                    item.docCargaDoc.cargaDoc
                                      .cargaDocUnidadeCarga[0]
                                      .pedidoUnidadeCarga
                                      .pedidoUnidadeCargaTrecho[0]
                                      .tabelaFreteRotaVig.tabelaFreteRota
                                      .tabelaFrete.cd
                                  }}
                                  -
                                  {{
                                    item.docCargaDoc.cargaDoc
                                      .cargaDocUnidadeCarga[0]
                                      .pedidoUnidadeCarga
                                      .pedidoUnidadeCargaTrecho[0]
                                      .tabelaFreteRotaVig.tabelaFreteRota
                                      .tabelaFrete.descr
                                  }}
                                </span>
                              </b-col>
                              <b-col>
                                <label><strong>Data Aprovação</strong></label>
                                <span>
                                  {{
                                    formatDate(
                                      item.docCargaDoc.cargaDoc
                                        .cargaDocUnidadeCarga[0]
                                        .pedidoUnidadeCarga
                                        .pedidoUnidadeCargaTrecho[0]
                                        .tabelaFreteRotaVig.dtAprovacao
                                    )
                                  }}
                                </span>
                              </b-col>
                              <b-col>
                                <label><strong>Tipo de Calculo</strong></label>
                                <span>
                                  {{
                                    item.docCargaDoc.cargaDoc
                                      .cargaDocUnidadeCarga[0]
                                      .pedidoUnidadeCarga
                                      .pedidoUnidadeCargaTrecho[0]
                                      .tabelaFreteRotaVig.tabelaFreteRota
                                      .tabelaFrete.tpCalculo
                                  }}
                                </span>
                              </b-col>
                              <b-col>
                                <label><strong>Valor faixa</strong></label>
                                <span
                                  v-if="item.docCargaDoc.doc.tpDoc.valor == 1"
                                >
                                  {{ formatNumber(item.vlrFaixa) }}
                                </span>
                              </b-col>
                              <b-col>
                                <label><strong>Range faixa</strong></label>
                                <span
                                  v-if="item.docCargaDoc.doc.tpDoc.valor == 1"
                                >
                                  {{ formatNumber(item.vlrFaixaIni) }} -
                                  {{ formatNumber(item.vlrFaixaFim) }}
                                </span>
                              </b-col>
                              <b-col>
                                <label><strong>Vigência</strong></label>
                                <span>
                                  {{
                                    formatDate(
                                      item.docCargaDoc.cargaDoc
                                        .cargaDocUnidadeCarga[0]
                                        .pedidoUnidadeCarga
                                        .pedidoUnidadeCargaTrecho[0]
                                        .tabelaFreteRotaVig.dtVigenciaIni
                                    )
                                  }}
                                  até
                                  {{
                                    formatDate(
                                      item.docCargaDoc.cargaDoc
                                        .cargaDocUnidadeCarga[0]
                                        .pedidoUnidadeCarga
                                        .pedidoUnidadeCargaTrecho[0]
                                        .tabelaFreteRotaVig.dtVigenciaFim
                                    )
                                  }}
                                </span>
                              </b-col>
                            </b-row>
                          </b-tab>

                          <!-- <b-tab title="Meio de transporte">
                            &lt;!&ndash; <div v-for="frota in this.dados.tipo_frota">
                        <b-row class="p-a-0" id="row" style="margin-top: 10px;">
                            <b-col md="2">
                                <label>Tipo de carroceria:  </label>
                                <span> {{frota.tp_carroceria}}</span>
                            </b-col>
                            <b-col md="2">
                                <label>Tipo rodado: </label>
                                <span> {{frota.tp_rodado}}</span>
                            </b-col>
                        </b-row>
                    </div> &ndash;&gt;
                          </b-tab> -->
                        </b-tabs>
                      </div>
                      <!--.tab-pane-->
                    </div>
                  </section>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade"
          v-bind:id="'t3' + rowData.docfisId + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 5%">N° MDFE</th>
                <th style="width: 10%">Dt Emissão</th>
                <th style="width: 5%">N° Romaneio</th>
                <th style="width: 10%">Dt Emissão</th>
                <th style="width: 5%">Peso(kg)</th>
                <th style="width: 20%">Chave</th>
                <th style="width: 5%">Qtd.NF</th>
                <th style="width: 5%">Qtd.CTE</th>
                <th style="width: 10%">Usuário Emissor</th>
                <th style="width: 10%">Usuário Evento</th>
                <th style="width: 5%">Data Evento</th>
                <th style="width: 5%">Status</th>
                <th style="width: 5%">Ações</th>
              </tr>
            </thead>
            <tbody v-for="item in rowData.cargaDocReentrega">
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-if="item.carga != null && item.carga.tpCarga == 2 && item.carga.status.valor == 3"
              >
                <td>
                  <span v-if="showMdfe(item)">
                    {{ item.docCargaDoc.doc.manifestoDoc.manifesto.numFiscal }}
                  </span>
                </td>
                <td>
                  <span v-if="showMdfe(item)">
                    {{ formatDate(item.docCargaDoc.doc.manifestoDoc.manifesto.dtEmi) }}
                  </span>
                </td>
                <td>
                  <span v-if="item.carga.tpOperacaoPrincipal == 3">
                    {{ item.carga.numCarga }}
                  </span>
                </td>
                <td>
                  <span v-if="item.carga.tpOperacaoPrincipal == 3">
                    {{ formatDate(item.carga.dtExpedicao) }}
                  </span>
                </td>
                <td>
                  <span>
                    {{ formatNumber(rowData.pesoBrutoTotal) }}
                  </span>
                </td>
                <td>
                  <span v-if="showMdfe(item)">
                    {{ item.docCargaDoc.doc.manifestoDoc.manifesto.chaveMdfe }}
                  </span>
                </td>
                <td>
                  <span>
                    {{ rowData.qtdTotalNf }}
                  </span>
                </td>
                <td>
                  <span>
                    {{ rowData.qtdTotalCte }}
                  </span>
                </td>
                <td>
                  <span
                    v-if="
                      showMdfe(item) &&
                      item.docCargaDoc.doc.manifestoDoc.manifesto.usuarioInc.pessoa != null
                    "
                  >
                    {{
                      setNomeSobrenome(
                        item.docCargaDoc.doc.manifestoDoc.manifesto.usuarioInc.pessoa.pessoaFisica.nome
                      )
                    }}
                  </span>
                </td>
                <td>
                  <span
                    v-if="
                      showMdfe(item) &&
                      item.docCargaDoc.doc.manifestoDoc.manifesto.manifestoEvento.length > 0 &&
                      item.docCargaDoc.doc.manifestoDoc.manifesto.manifestoEvento[0].usuarioInc
                        .pessoa != null
                    "
                  >
                    {{
                      setNomeSobrenome(
                        item.docCargaDoc.doc.manifestoDoc.manifesto.manifestoEvento[0].usuarioInc
                          .pessoa.pessoaFisica.nome
                      )
                    }}
                  </span>
                </td>
                <td>
                  <span
                    v-if="
                      showMdfe(item) &&
                      item.docCargaDoc.doc.manifestoDoc.manifesto.manifestoEvento.length > 0
                    "
                  >
                    {{
                      formatDate(
                        item.docCargaDoc.doc.manifestoDoc.manifesto.manifestoEvento[0].sefazDtHrEvento
                      )
                    }}
                  </span>
                </td>
                <td>
                  <span
                    class="badge badge-danger"
                    v-if="
                      showMdfe(item) &&
                      item.docCargaDoc.doc.manifestoDoc.manifesto.status.valor == 14
                    "
                    >{{ item.docCargaDoc.doc.manifestoDoc.manifesto.status.descr }}</span
                  >
                  <span
                    class="badge badge-info"
                    v-if="
                      showMdfe(item) &&
                      item.docCargaDoc.doc.manifestoDoc.manifesto.status.valor == 21
                    "
                    >{{ item.docCargaDoc.doc.manifestoDoc.manifesto.status.descr }}</span
                  >
                  <span
                    class="badge badge-warning"
                    v-if="
                      showMdfe(item) &&
                      item.docCargaDoc.doc.manifestoDoc.manifesto.status.valor == 34
                    "
                    >{{ item.docCargaDoc.doc.manifestoDoc.manifesto.status.descr }}</span
                  >
                  <span
                    class="badge badge-warning"
                    v-if="
                      showMdfe(item) &&
                      item.docCargaDoc.doc.manifestoDoc.manifesto.status.valor == 31
                    "
                    >{{ item.docCargaDoc.doc.manifestoDoc.manifesto.status.descr }}</span
                  >
                  <span
                    class="badge badge-danger"
                    v-if="
                      showMdfe(item) &&
                      item.docCargaDoc.doc.manifestoDoc.manifesto.status.valor == 9
                    "
                    >{{ item.docCargaDoc.doc.manifestoDoc.manifesto.status.descr }}</span
                  >
                  <span
                    class="badge badge-danger"
                    v-if="
                      showMdfe(item) &&
                      item.docCargaDoc.doc.manifestoDoc.manifesto.status.valor == 8
                    "
                    >{{ item.docCargaDoc.doc.manifestoDoc.manifesto.status.descr }}</span
                  >
                  <span
                    class="badge badge-danger"
                    v-if="
                      showMdfe(item) &&
                      item.docCargaDoc.doc.manifestoDoc.manifesto.status.valor == 7
                    "
                    >{{ item.docCargaDoc.doc.manifestoDoc.manifesto.status.descr }}</span
                  >
                  <span
                    class="badge badge-warning"
                    v-if="
                      showMdfe(item) &&
                      item.docCargaDoc.doc.manifestoDoc.manifesto.status.valor == 22
                    "
                    >{{ item.docCargaDoc.doc.manifestoDoc.manifesto.status.descr }}</span
                  >
                  <span
                    class="badge badge-warning"
                    v-if="
                      showMdfe(item) &&
                      item.docCargaDoc.doc.manifestoDoc.manifesto.status.valor == 12
                    "
                    >{{ item.docCargaDoc.doc.manifestoDoc.manifesto.status.descr }}</span
                  >
                  <span
                    class="badge badge-success"
                    v-if="
                      showMdfe(item) &&
                      item.docCargaDoc.doc.manifestoDoc.manifesto.status.valor == 6
                    "
                    >{{ item.docCargaDoc.doc.manifestoDoc.manifesto.status.descr }}</span
                  >
                  <span
                    class="badge badge-info"
                    v-if="
                      showMdfe(item) &&
                      item.docCargaDoc.doc.manifestoDoc.manifesto.status.valor == 3
                    "
                    >{{ item.docCargaDoc.doc.manifestoDoc.manifesto.status.descr }}</span
                  >
                  <span
                    class="badge badge-info"
                    v-if="
                      showMdfe(item) &&
                      item.docCargaDoc.doc.manifestoDoc.manifesto.status.valor == 32
                    "
                    >{{ item.docCargaDoc.doc.manifestoDoc.manifesto.status.descr }}</span
                  >
                  <span
                    class="badge badge-info"
                    v-if="
                      showMdfe(item) &&
                      item.docCargaDoc.doc.manifestoDoc.manifesto.status.valor == 2
                    "
                    >{{ item.docCargaDoc.doc.manifestoDoc.manifesto.status.descr }}</span
                  >
                  <span
                    class="badge badge-warning"
                    v-if="
                      showMdfe(item) &&
                      item.docCargaDoc.doc.manifestoDoc.manifesto.status.valor == 1
                    "
                    >{{ item.docCargaDoc.doc.manifestoDoc.manifesto.status.descr }}</span
                  >
                  <span
                    class="badge badge-warning"
                    v-if="
                      showMdfe(item) &&
                      item.docCargaDoc.doc.manifestoDoc.manifesto.status.valor == 4
                    "
                    >{{ item.docCargaDoc.doc.manifestoDoc.manifesto.status.descr }}</span
                  >
                  <span
                    class="badge badge-warning"
                    v-if="
                      showMdfe(item) &&
                      item.docCargaDoc.doc.manifestoDoc.manifesto.status.valor == 5
                    "
                    >{{ item.docCargaDoc.doc.manifestoDoc.manifesto.status.descr }}</span
                  >
                  <span
                    class="badge badge-warning"
                    v-if="
                      showMdfe(item) &&
                      item.docCargaDoc.doc.manifestoDoc.manifesto.status.valor == 11
                    "
                    >{{ item.docCargaDoc.doc.manifestoDoc.manifesto.status.descr }}</span
                  >
                </td>
                <td>
                  <a
                    v-if="showMdfe(item)"
                    @click="onExportCsv(item.docCargaDoc.doc.manifestoDoc.manifesto.manifestoId)"
                    v-b-tooltip
                    title="Exportar chaves em .csv"
                    ><i class="fa fa-file-code-o"></i
                  ></a>
                  <a
                    v-if="item.carga.tpOperacaoPrincipal == 3"
                    @click="onPrintRomaneio(item.carga.cargaId)"
                    v-b-tooltip
                    title="Imprimir romaneio"
                    ><i class="fa fa-file-code-o"></i
                  ></a>
                  <span
                    v-if="
                      showMdfe(item) &&
                      (item.docCargaDoc.doc.manifestoDoc.manifesto.status.valor == 6 ||
                        item.docCargaDoc.doc.manifestoDoc.manifesto.status.valor == 11 ||
                        item.docCargaDoc.doc.manifestoDoc.manifesto.status.valor == 21)
                    "
                    ><a
                      @click="onImprimirMdfe(item.docCargaDoc.doc.manifestoDoc.manifesto.manifestoId)"
                      v-b-tooltip
                      title="Imprimir MDFE"
                      ><i class="fa fa-print"></i></a
                  ></span>
                  <span
                    v-if="
                      showMdfe(item) &&
                      item.docCargaDoc.doc.manifestoDoc.manifesto.manifestoXml.length > 0
                    "
                    ><a
                      @click="
                        onDownloadXmlMdfe(item.docCargaDoc.doc.manifestoDoc.manifesto.manifestoId)
                      "
                      v-b-tooltip
                      title="Download Xml"
                      ><i class="fa fa-download"></i></a
                  ></span>
                  <div v-if="rowData.cargaDoc.docCargaDoc && rowData.cargaDoc.docCargaDoc.doc.tpDoc.valor == 2">
                    <span v-if="getPermission('cte.imprimir')">
                      <span>
                        <a
                          @click="
                            onDownloadXml(
                              null,
                              rowData.cargaDoc.docCargaDoc.doc.docRps.docrpsId
                            )
                          "
                          v-if="
                            rowData.cargaDoc.docCargaDoc.doc.docRps.docRpsXml
                              .length > 0
                          "
                          v-b-tooltip
                          title="Download XML"
                          ><i class="fa fa-code"></i
                        ></a>
                      </span>
                    </span>
                  </div>
                  <a
                    @click="onExportNotfis(rowData.docfisId)"
                    v-b-tooltip
                    title="Exportar Notfis"
                    ><i class="ft-download"></i
                  ></a>
                  <span v-if="rowData.cargaDoc.docCargaDoc">
                    <span>
                      <a
                        @click="
                          onImprimirRps(
                            rowData.cargaDoc.docCargaDoc.doc.docId,
                            rowData.cargaDoc.docCargaDoc.doc.tpDoc.valor
                          )
                        "
                        v-if="rowData.cargaDoc.docCargaDoc.doc.docRps != null"
                        v-b-tooltip
                        title="Imprimir RPS"
                        ><i class="fa fa-download"></i
                      ></a>
                    </span>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade"
          v-if="rowData.cargaBipDocMany.length > 0"
          v-bind:id="'t4' + rowData.docfisId + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 5%">N° Fiscal</th>
                <th style="width: 5%">Carga</th>
                <th style="width: 10%">Valor NF</th>
                <th style="width: 5%">Peso NF</th>
                <th style="width: 5%">Qtde.</th>
                <th style="width: 15%">CNPJ Emi.</th>
                <th style="width: 25%">Razão Social Emi.</th>
                <th style="width: 15%">Redespacho</th>
                <th style="width: 15%">Usuário Liberação Especial</th>
                <th style="width: 15%">Dt. Liberação Especial</th>
                <th style="width: 5%">Status</th>
                <th style="width: 5%">Ações</th>
              </tr>
            </thead>
            <tbody v-for="item in rowData.cargaBipDocMany">
              <tr :class="onRowClass(item)" style="display: table-row">
                <td>{{ rowData.numFiscal }}</td>
                <td>{{ item.cargaId }}</td>
                <td>R$ {{ formatNumber(rowData.vlrTotalNfs) }}</td>
                <td>{{ formatNumber(rowData.pesoBrutoTotalNf) }}</td>
                <td>
                  {{ rowData.qtdNotasBipadasMontagem }}/{{
                    rowData.qtdTotalBipVolumes
                  }}
                </td>
                <td>
                  {{ ajustaMascara(rowData.docFiscalPartesEnv.emiCnpj) }}
                </td>
                <td>{{ rowData.docFiscalPartesEnv.emiNome }}</td>
                <td>{{ rowData.docFiscalPartesEnv.redNome }}</td>
                <td>
                  <span
                    v-if="
                      rowData.cargaDoc.carga.usuarioLiberacaoMontagem != null
                    "
                  >
                    {{ rowData.cargaDoc.carga.usuarioLiberacaoMontagem.email }}
                  </span>
                </td>
                <td>
                  <span
                    v-if="rowData.cargaDoc.carga.dtLiberacaoMontagem != null"
                  >
                    {{
                      formatDateSeconds(
                        rowData.cargaDoc.carga.dtLiberacaoMontagem
                      )
                    }}
                  </span>
                </td>
                <td>
                  <span
                    class="badge badge-success"
                    v-if="
                      rowData.cargaDoc.carga.status.valor == 3 ||
                      rowData.cargaDoc.carga.status.valor == 6
                    "
                    >{{ rowData.cargaDoc.carga.status.descr }}</span
                  >
                  <span
                    class="badge badge-warning"
                    v-if="rowData.cargaDoc.carga.status.valor == 1"
                    >{{ rowData.cargaDoc.carga.status.descr }}</span
                  >
                </td>
                <td>
                  <a
                    @click="onDetail(item.carbipdocId)"
                    v-b-tooltip
                    title="Ver Detalhes"
                    ><i class="fa fa-plus"></i
                  ></a>
                </td>
              </tr>
              <tr v-if="isVisibleDetail(item.carbipdocId)">
                <td colspan="12">
                  <section class="tabs-section">
                    <ul
                      class="nav nav-tabs nav-topline nav-justified"
                      role="tablist"
                    >
                      <li class="nav-item">
                        <a class="nav-link active" role="tab" data-toggle="tab">
                          <span class="nav-link-in"> Volumes </span>
                        </a>
                      </li>
                    </ul>
                    <div class="tab-content">
                      <div
                        role="tabpanel"
                        class="tab-pane fade in active show pt-1 border-color-detalhes-grey"
                        v-bind:id="'tbmc4' + item.carbipdocId + ''"
                      >
                        <table
                          :class="['vuetable table table-striped tbl-typical']"
                        >
                          <thead>
                            <tr>
                              <th style="width: 10%">N° Volume</th>
                              <th style="width: 35%">Status do Volume</th>
                              <th style="width: 35%">Usuario Bip</th>
                              <th style="width: 35%">Data Bip</th>
                            </tr>
                          </thead>
                          <tbody v-for="(item2, i) in item.cargaBipDocVolume">
                            <tr
                              class="bg-gray-light"
                              style="display: table-row"
                            >
                              <td>
                                {{ item2.numVolume }}
                              </td>
                              <td>
                                <span
                                  class="badge badge-success"
                                  v-if="item2.statusMontagem.valor == 1"
                                  >{{ item2.statusMontagem.descr }}</span
                                >
                                <span
                                  class="badge badge-danger"
                                  v-if="item2.statusMontagem.valor == 2"
                                  >{{ item2.statusMontagem.descr }}</span
                                >
                                <span
                                  class="badge badge-warning"
                                  v-if="item2.statusMontagem.valor == 3"
                                  >{{ item2.statusMontagem.descr }} - Via
                                  seleção / Inserido via chave de CTe</span
                                >
                              </td>
                              <td>
                                <span v-if="item2.usuarioBipMontagem != null">{{
                                  item2.usuarioBipMontagem.pessoa.pessoaFisica
                                    .nome
                                }}</span>
                                <span v-if="item2.statusMontagem.valor == 3">{{
                                  item2.usuarioInc.pessoa.pessoaFisica.nome
                                }}</span>
                              </td>
                              <td>
                                <span v-if="item2.usuarioBipMontagem != null">{{
                                  formatDateSeconds(item2.dtBipMontagem)
                                }}</span>
                                <span v-if="item2.statusMontagem.valor == 3">{{
                                  formatDateSeconds(item2.dtInc)
                                }}</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </section>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade"
          v-if="rowData.cargaBipDocMany.length > 0"
          v-bind:id="'t5' + rowData.docfisId + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 5%">N° Fiscal</th>
                <th style="width: 5%">Carga</th>
                <th style="width: 10%">Valor NF</th>
                <th style="width: 5%">Peso</th>
                <th style="width: 5%">Qtde.</th>
                <th style="width: 15%">CNPJ Emi.</th>
                <th style="width: 25%">Razão Social Emi.</th>
                <th style="width: 15%">Redespacho</th>
                <th style="width: 15%">Exige conferência ?</th>
                <th style="width: 15%">Usuário Liberação Especial</th>
                <th style="width: 15%">Dt. Liberação Especial</th>
                <th style="width: 5%">Status</th>
                <th style="width: 5%">Ações</th>
              </tr>
            </thead>
            <tbody v-for="item in rowData.cargaBipDocMany">
              <tr :class="onRowClass(item)" style="display: table-row">
                <td>{{ rowData.numFiscal }}</td>
                <td>{{ item.cargaId }}</td>
                <td>R$ {{ formatNumber(rowData.vlrTotalNfs) }}</td>
                <td>{{ formatNumber(rowData.pesoBrutoTotal) }}</td>
                <td>
                  {{ rowData.qtdNotasBipadasExpedicao }}/{{
                    rowData.qtdTotalBipVolumes
                  }}
                </td>
                <td>
                  {{ ajustaMascara(rowData.docFiscalPartesEnv.emiCnpj) }}
                </td>
                <td>{{ rowData.docFiscalPartesEnv.emiNome }}</td>
                <td>{{ rowData.docFiscalPartesEnv.redNome }}</td>
                <td>
                  <span
                    class="badge badge-danger"
                    v-if="rowData.exigeConferenciaExp.valor == 2"
                    >{{ rowData.exigeConferenciaExp.descr }}</span
                  >
                  <span
                    class="badge badge-success"
                    v-if="rowData.exigeConferenciaExp.valor == 1"
                    >{{ rowData.exigeConferenciaExp.descr }}</span
                  >
                </td>
                <td>
                  <span
                    v-if="
                      rowData.cargaDoc.carga.usuarioLiberacaoExpedicao != null
                    "
                  >
                    {{ rowData.cargaDoc.carga.usuarioLiberacaoExpedicao.email }}
                  </span>
                </td>
                <td>
                  <span
                    v-if="rowData.cargaDoc.carga.dtLiberacaoExpedicao != null"
                  >
                    {{
                      formatDateSeconds(
                        rowData.cargaDoc.carga.dtLiberacaoExpedicao
                      )
                    }}
                  </span>
                </td>
                <td>
                  <span
                    class="badge badge-success"
                    v-if="
                      rowData.cargaDoc.carga.status.valor == 3 ||
                      rowData.cargaDoc.carga.status.valor == 6
                    "
                    >{{ rowData.cargaDoc.carga.status.descr }}</span
                  >
                  <span
                    class="badge badge-warning"
                    v-if="rowData.cargaDoc.carga.status.valor == 1"
                    >{{ rowData.cargaDoc.carga.status.descr }}</span
                  >
                </td>
                <td>
                  <a
                    @click="onDetail(item.carbipdocId)"
                    v-b-tooltip
                    title="Ver Detalhes"
                    ><i class="fa fa-plus"></i
                  ></a>
                </td>
              </tr>

              <tr v-if="isVisibleDetail(item.carbipdocId)">
                <td colspan="12">
                  <section class="tabs-section">
                    <ul
                      class="nav nav-tabs nav-topline nav-justified"
                      role="tablist"
                    >
                      <li class="nav-item">
                        <a class="nav-link active" role="tab" data-toggle="tab">
                          <span class="nav-link-in"> Volumes </span>
                        </a>
                      </li>
                    </ul>
                    <div class="tab-content">
                      <div
                        role="tabpanel"
                        class="tab-pane fade in active show pt-1 border-color-detalhes-grey"
                        v-bind:id="'tbe4' + item.carbipdocId + ''"
                      >
                        <table
                          :class="['vuetable table table-striped tbl-typical']"
                        >
                          <thead>
                            <tr>
                              <th style="width: 10%">N° Volume</th>
                              <th style="width: 35%">Status do Volume</th>
                              <th style="width: 35%">Usuario Bip</th>
                              <th style="width: 35%">Data Bip</th>
                            </tr>
                          </thead>
                          <tbody v-for="(item2, i) in item.cargaBipDocVolume">
                            <tr
                              class="bg-gray-light"
                              style="display: table-row"
                            >
                              <td>
                                {{ item2.numVolume }}
                              </td>
                              <td>
                                <span
                                  class="badge badge-success"
                                  v-if="item2.statusExpedicao.valor == 1"
                                  >{{ item2.statusExpedicao.descr }}</span
                                >
                                <span
                                  class="badge badge-danger"
                                  v-if="item2.statusExpedicao.valor == 2"
                                  >{{ item2.statusExpedicao.descr }}</span
                                >
                                <span
                                  class="badge badge-warning"
                                  v-if="item2.statusExpedicao.valor == 3"
                                  >{{ item2.statusExpedicao.descr }}</span
                                >
                              </td>
                              <td>
                                <span
                                  v-if="item2.usuarioBipExpedicao != null"
                                  >{{
                                    item2.usuarioBipExpedicao.pessoa
                                      .pessoaFisica.nome
                                  }}</span
                                >
                              </td>
                              <td>
                                {{ formatDateSeconds(item2.dtBipExpedicao) }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </section>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade"
          v-bind:id="'t6' + rowData.docfisId + ''"
          v-if="rowData.docTranspDocfis != null"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 5%">Tipo Doc.</th>
                <th style="width: 10%">N° Doc</th>
                <th style="width: 5%">Série</th>
                <th style="width: 10%">Dt. Lançamento</th>
                <th style="width: 10%">Vlr. Doc</th>
                <th style="width: 10%">Dt. Emissão</th>
                <th style="width: 10%">Dt. Vencimento</th>
                <th style="width: 10%">Status ERP</th>
                <th style="width: 10%">Status</th>
                <th style="width: 10%">Ações</th>
              </tr>
            </thead>
            <tbody
              v-for="(item, i) in rowData.docTranspDocfis.docTransp
                .preFaturaDespesaDoc"
            >
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-if="item.preFaturaDespesaDoc != null"
              >
                <td>
                  <span class="badge badge-success"
                    >Pré Fatura - {{ item.preFaturaDespesa.tpPreFatura }}</span
                  >
                </td>
                <td>
                  <span v-if="item.preFaturaDespesa != null">
                    {{ item.preFaturaDespesa.numFiscal }}
                  </span>
                </td>
                <td>
                  <span v-if="item.preFaturaDespesa != null">
                    {{ item.preFaturaDespesa.serie }}
                  </span>
                </td>
                <td>
                  <span v-if="item.preFaturaDespesa != null">
                    {{ formatDate(item.preFaturaDespesa.dtInc) }}
                  </span>
                </td>
                <td>
                  <span v-if="rowData.docTranspDocfis != null">
                    {{ formatNumber(item.preFaturaDespesa.vlrPreFatura) }}
                  </span>
                </td>

                <td>
                  <span v-if="item.preFaturaDespesa != null">
                    {{ formatDate(item.preFaturaDespesa.dtEmi) }}
                  </span>
                </td>
                <td>
                  <span v-if="item.preFaturaDespesa != null">
                    {{ formatDate(item.preFaturaDespesa.dtVencto) }}
                  </span>
                </td>
                <td></td>
                <td>
                  <span
                    class="badge badge-secondary"
                    v-if="item.preFaturaDespesa.status.valor == 1"
                    >{{ item.preFaturaDespesa.status.descr }}
                  </span>
                  <span
                    class="badge badge-success"
                    v-if="item.preFaturaDespesa.status.valor == 2"
                    >{{ item.preFaturaDespesa.status.descr }}
                  </span>
                  <span
                    class="badge badge-warning"
                    v-if="item.preFaturaDespesa.status.valor == 3"
                    >{{ item.preFaturaDespesa.status.descr }}
                  </span>
                  <span
                    class="badge badge-danger"
                    v-if="item.preFaturaDespesa.status.valor == 4"
                    >{{ item.preFaturaDespesa.status.descr }}
                  </span>
                  <span
                    class="badge badge-info"
                    v-if="item.preFaturaDespesa.status.valor == 5"
                    >{{ item.preFaturaDespesa.status.descr }}
                  </span>
                </td>
                <td>
                  <a
                    @click="onDetail(item.prefatdesdocId)"
                    v-b-tooltip
                    title="Ver Detalhes"
                    ><i class="fa fa-plus"></i
                  ></a>
                </td>
              </tr>

              <tr v-if="isVisibleDetail(item.prefatdesdocId)">
                <td colspan="12">
                  <section class="tabs-section">
                    <div class="tab-content">
                      <div
                        role="tabpanel"
                        class="tab-pane fade in active show pt-1 border-color-detalhes-grey"
                        v-bind:id="'tr5' + item.prefatdesdocId + ''"
                      >
                        <table
                          :class="['vuetable table table-striped tbl-typical']"
                        >
                          <thead>
                            <tr>
                              <th style="width: 10%">Dt. e Horario</th>
                              <th style="width: 10%">Usuario Inc.</th>
                              <th style="width: 10%">Qtd.Nf</th>
                              <th style="width: 10%">Qtd.CTE</th>
                              <th style="width: 10%">Dt. Conferência</th>
                              <th style="width: 10%">Usuario Conferência</th>
                              <th style="width: 10%">Dt. Reprova</th>
                              <th style="width: 10%">Usuario Reprovação</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              class="bg-gray-light"
                              style="display: table-row"
                            >
                              <td>
                                <span>
                                  {{ formatDate(item.preFaturaDespesa.dtInc) }}
                                </span>
                              </td>
                              <td>
                                <span>
                                  {{ item.preFaturaDespesa.usuarioInc.email }}
                                </span>
                              </td>
                              <td>
                                {{
                                  rowData.docTranspDocfis.docTransp
                                    .preFaturaDespesaDoc.length
                                }}
                              </td>
                              <td>
                                {{
                                  rowData.docTranspDocfis.docTransp
                                    .qtdeTotalCtes
                                }}
                              </td>
                              <td>
                                <span>
                                  {{
                                    formatDate(
                                      item.preFaturaDespesa.dtLiberacao
                                    )
                                  }}
                                </span>
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.preFaturaDespesa.usuarioLiberacao !=
                                    null
                                  "
                                >
                                  {{
                                    item.preFaturaDespesa.usuarioLiberacao.email
                                  }}
                                </span>
                              </td>
                              <td>
                                <span>
                                  {{
                                    formatDate(
                                      item.preFaturaDespesa.dtCancelamento
                                    )
                                  }}
                                </span>
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.preFaturaDespesa.usuarioCancelamento !=
                                    null
                                  "
                                >
                                  {{
                                    item.preFaturaDespesa.usuarioCancelamento
                                      .email
                                  }}
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </section>
                </td>
              </tr>
            </tbody>

            <!--FATURA DESPESA-->

            <tbody
              v-for="(item, i) in rowData.docTranspDocfis.docTransp
                .faturaDespesaDoc"
            >
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-if="item.faturaDespesa != null"
              >
                <td>
                  <span class="badge badge-info"
                    >Fatura - {{ item.faturaDespesa.tpFatura }}</span
                  >
                </td>
                <td>
                  <span v-if="item.faturaDespesa != null">
                    {{ item.faturaDespesa.numFiscal }}
                  </span>
                </td>
                <td>
                  <span v-if="item.faturaDespesa != null">
                    {{ item.faturaDespesa.serie }}
                  </span>
                </td>
                <td>
                  <span v-if="item.faturaDespesa != null">
                    {{ formatDate(item.faturaDespesa.dtInc) }}
                  </span>
                </td>
                <td>
                  <span v-if="rowData.docTranspDocfis != null">
                    {{ formatNumber(item.faturaDespesa.vlrFatura) }}
                  </span>
                </td>

                <td>
                  <span v-if="item.faturaDespesa != null">
                    {{ formatDate(item.faturaDespesa.dtEmi) }}
                  </span>
                </td>
                <td>
                  <span v-if="item.faturaDespesa != null">
                    {{ formatDate(item.faturaDespesa.dtVencto) }}
                  </span>
                </td>
                <td>
                  <span
                    class="badge badge-success"
                    v-if="item.faturaDespesa.statusEnvioIntegracao.valor == 1"
                    >{{ item.faturaDespesa.statusEnvioIntegracao.descr }}
                  </span>
                  <span
                    class="badge badge-warning"
                    v-if="item.faturaDespesa.statusEnvioIntegracao.valor == 2"
                    >{{ item.faturaDespesa.statusEnvioIntegracao.descr }}
                  </span>
                  <span
                    class="badge badge-danger"
                    v-if="item.faturaDespesa.statusEnvioIntegracao.valor == 3"
                    >{{ item.faturaDespesa.statusEnvioIntegracao.descr }}
                  </span>
                </td>
                <td>
                  <span
                    class="badge badge-secondary"
                    v-if="item.faturaDespesa.status.valor == 1"
                    >{{ item.faturaDespesa.status.descr }}
                  </span>
                  <span
                    class="badge badge-success"
                    v-if="item.faturaDespesa.status.valor == 2"
                    >{{ item.faturaDespesa.status.descr }}
                  </span>
                  <span
                    class="badge badge-warning"
                    v-if="item.faturaDespesa.status.valor == 3"
                    >{{ item.faturaDespesa.status.descr }}
                  </span>
                  <span
                    class="badge badge-danger"
                    v-if="item.faturaDespesa.status.valor == 4"
                    >{{ item.faturaDespesa.status.descr }}
                  </span>
                  <span
                    class="badge badge-info"
                    v-if="item.faturaDespesa.status.valor == 5"
                    >{{ item.faturaDespesa.status.descr }}
                  </span>
                </td>
                <td>
                  <a
                    @click="onDetail(item.fatdesdocId)"
                    v-b-tooltip
                    title="Ver Detalhes"
                    ><i class="fa fa-plus"></i
                  ></a>
                </td>
              </tr>

              <tr v-if="isVisibleDetail(item.fatdesdocId)">
                <td colspan="12">
                  <section class="tabs-section">
                    <div class="tab-content">
                      <div
                        role="tabpanel"
                        class="tab-pane fade in active show pt-1 border-color-detalhes-grey"
                        v-bind:id="'tr5' + item.fatdesdocId + ''"
                      >
                        <table
                          :class="['vuetable table table-striped tbl-typical']"
                        >
                          <thead>
                            <tr>
                              <th style="width: 10%">Dt. e Horario</th>
                              <th style="width: 10%">Usuario Inc.</th>
                              <th style="width: 10%">Qtd.Nf</th>
                              <th style="width: 10%">Qtd.CTE</th>
                              <th style="width: 10%">Dt. Conferência</th>
                              <th style="width: 10%">Usuario Conferência</th>
                              <th style="width: 10%">Dt. Reprova</th>
                              <th style="width: 10%">Usuario Reprovação</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              class="bg-gray-light"
                              style="display: table-row"
                            >
                              <td>
                                <span>
                                  {{ formatDate(item.faturaDespesa.dtInc) }}
                                </span>
                              </td>
                              <td>
                                <span>
                                  {{ item.faturaDespesa.usuarioInc.email }}
                                </span>
                              </td>
                              <td>
                                {{
                                  rowData.docTranspDocfis.docTransp
                                    .faturaDespesaDoc.length
                                }}
                              </td>
                              <td>
                                {{
                                  rowData.docTranspDocfis.docTransp
                                    .qtdeTotalCtes
                                }}
                              </td>
                              <td>
                                <span>
                                  {{
                                    formatDate(item.faturaDespesa.dtLiberacao)
                                  }}
                                </span>
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.faturaDespesa.usuarioLiberacao != null
                                  "
                                >
                                  {{
                                    item.faturaDespesa.usuarioLiberacao.email
                                  }}
                                </span>
                              </td>
                              <td>
                                <span>
                                  {{
                                    formatDate(
                                      item.faturaDespesa.dtCancelamento
                                    )
                                  }}
                                </span>
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.faturaDespesa.usuarioCancelamento !=
                                    null
                                  "
                                >
                                  {{
                                    item.faturaDespesa.usuarioCancelamento.email
                                  }}
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </section>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade"
          v-if="
            rowData.cargaDoc != null &&
            rowData.cargaDoc.pedidoUnidadeCargaTrechoDoc[0] != null &&
            rowData.cargaDoc.pedidoUnidadeCargaTrechoDoc[0]
              .pedidoUnidadeCargaTrecho.pedidoUnidadeCargaTrechoAudit != null &&
            rowData.cargaDoc.pedidoUnidadeCargaTrechoDoc[0]
              .pedidoUnidadeCargaTrecho.pedidoUnidadeCargaTrechoAudit
              .auditoriaFrete.docTransp != null
          "
          v-bind:id="'t7' + rowData.docfisId + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 5%">Tipo Doc.</th>
                <th style="width: 5%">N° Cte/Rps</th>
                <th style="width: 5%">Serie</th>
                <th style="width: 20%">Chave</th>
                <th style="width: 5%">Qtde. NF</th>
                <th style="width: 5%">Qtde. CTe</th>
                <th style="width: 10%">Data Emissão</th>
                <th style="width: 5%">Vlr.Doc</th>
                <th style="width: 15%">Nome Emitente</th>
                <th style="width: 10%">CNPJ/CPF Emitente</th>
                <th style="width: 5%">Vlr.Calculo</th>
                <th style="width: 5%">Status</th>
                <th style="width: 5%">Ações</th>
              </tr>
            </thead>
            <tbody v-for="item in rowData.cargaDoc.pedidoUnidadeCargaTrechoDoc">
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-if="item.pedidoUnidadeCargaTrecho.tpCusto == 2"
              >
                <td>
                  <span
                    v-if="
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit != null &&
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete
                        .docTransp != null
                    "
                  >
                    {{
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete.docTransp
                        .livTpDoc.descr
                    }}
                  </span>
                </td>
                <td>
                  <span
                    v-if="
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit != null &&
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete
                        .docTransp != null
                    "
                  >
                    {{
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete.docTransp
                        .numDoc
                    }}
                  </span>
                </td>
                <td>
                  <span
                    v-if="
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit != null &&
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete
                        .docTransp != null
                    "
                  >
                    {{
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete.docTransp
                        .serie
                    }}
                  </span>
                </td>
                <td>
                  <span
                    v-if="
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit != null &&
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete
                        .docTransp != null
                    "
                  >
                    {{
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete.docTransp
                        .chave
                    }}
                  </span>
                </td>
                <td>
                  <span
                    v-if="
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit != null &&
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete
                        .docTransp != null
                    "
                  >
                    {{
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete.docTransp
                        .totalNfs
                    }}
                  </span>
                </td>
                <td>
                  <span
                    v-if="
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit != null &&
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete
                        .docTransp != null
                    "
                  >
                    {{
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete.docTransp
                        .auditoriaFrete.pedidoUnidadeCargaTrechoAudit.length
                    }}
                  </span>
                </td>
                <td>
                  <span
                    v-if="
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit != null &&
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete
                        .docTransp != null
                    "
                  >
                    {{
                      formatDate(
                        item.pedidoUnidadeCargaTrecho
                          .pedidoUnidadeCargaTrechoAudit.auditoriaFrete
                          .docTransp.dtEmissao
                      )
                    }}
                  </span>
                </td>
                <td>
                  <span
                    v-if="
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit != null &&
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete
                        .docTransp != null
                    "
                  >
                    {{
                      formatNumber(
                        item.pedidoUnidadeCargaTrecho
                          .pedidoUnidadeCargaTrechoAudit.auditoriaFrete
                          .docTransp.docTranspVlrPrestacao.vlrReceber
                      )
                    }}
                  </span>
                </td>
                <td>
                  <span
                    v-if="
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit != null &&
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete
                        .docTransp != null
                    "
                  >
                    {{
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete.docTransp
                        .docTranspPartesEnv.emiNome
                    }}
                  </span>
                </td>
                <td>
                  <span
                    v-if="
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit != null &&
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete
                        .docTransp != null
                    "
                  >
                    {{
                      ajustaMascara(
                        item.pedidoUnidadeCargaTrecho
                          .pedidoUnidadeCargaTrechoAudit.auditoriaFrete
                          .docTransp.docTranspPartesEnv.emiCnpj
                      )
                    }}
                  </span>
                </td>
                <td>
                  <span
                    v-if="
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit != null &&
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete
                        .docTransp != null
                    "
                  >
                    {{
                      formatNumber(
                        item.pedidoUnidadeCargaTrecho
                          .pedidoUnidadeCargaTrechoAudit.auditoriaFrete
                          .docTransp.vlrCalculo
                      )
                    }}
                  </span>
                </td>
                <td>
                  <span
                    class="badge badge-warning"
                    v-if="
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete.status
                        .valor == 1
                    "
                    >{{
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete.status
                        .descr
                    }}
                  </span>
                  <span
                    class="badge badge-info"
                    v-if="
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete.status
                        .valor == 2
                    "
                    >{{
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete.status
                        .descr
                    }}
                  </span>
                  <span
                    class="badge badge-warning"
                    v-if="
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete.status
                        .valor == 3
                    "
                    >{{
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete.status
                        .descr
                    }}
                  </span>
                  <span
                    class="badge badge-danger"
                    v-if="
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete.status
                        .valor == 4
                    "
                    >{{
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete.status
                        .descr
                    }}
                  </span>
                </td>
                <td>
                  <a
                    @click="onDetail(rowData.docfisId)"
                    v-b-tooltip
                    v-if="
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit != null &&
                      item.pedidoUnidadeCargaTrecho
                        .pedidoUnidadeCargaTrechoAudit.auditoriaFrete
                        .docTransp != null
                    "
                    title="Ver Detalhes"
                    ><i class="fa fa-plus"></i
                  ></a>
                </td>
              </tr>

              <tr
                v-if="
                  isVisibleDetail(rowData.docfisId) &&
                  item.pedidoUnidadeCargaTrecho.tpCusto == 2
                "
              >
                <td colspan="12">
                  <section class="tabs-section">
                    <div class="tab-content">
                      <div
                        role="tabpanel"
                        class="tab-pane fade in active show pt-1 border-color-detalhes-grey"
                        v-bind:id="'tr5' + rowData.docfisId + ''"
                      >
                        <table
                          :class="['vuetable table table-striped tbl-typical']"
                        >
                          <thead>
                            <tr>
                              <th style="width: 10%">Usuario Inc.</th>
                              <th style="width: 10%">Dt. e Horario</th>
                              <th style="width: 10%">Usuario Assoc.</th>
                              <th style="width: 10%">Data Assoc.</th>
                              <th style="width: 10%">Dt. Conferência</th>
                              <th style="width: 10%">Usuario Conferência</th>
                              <th style="width: 10%">Dt. Aprovação</th>
                              <th style="width: 10%">Usuario Aprovação</th>
                              <th style="width: 10%">Dt. Reprova</th>
                              <th style="width: 10%">Usuario Reprovação</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              class="bg-gray-light"
                              style="display: table-row"
                            >
                              <td>
                                <span
                                  v-if="
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit != null &&
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit
                                      .auditoriaFrete.docTransp != null
                                  "
                                >
                                  {{
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit
                                      .auditoriaFrete.usuarioInc.email
                                  }}
                                </span>
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit != null &&
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit
                                      .auditoriaFrete.docTransp != null
                                  "
                                >
                                  {{
                                    formatDate(
                                      item.pedidoUnidadeCargaTrecho
                                        .pedidoUnidadeCargaTrechoAudit
                                        .auditoriaFrete.dtInc
                                    )
                                  }}
                                </span>
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit != null
                                  "
                                >
                                  {{
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit.usuarioInc
                                      .email
                                  }}
                                </span>
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit != null &&
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit
                                      .auditoriaFrete.docTransp != null
                                  "
                                >
                                  {{
                                    formatDate(
                                      item.pedidoUnidadeCargaTrecho
                                        .pedidoUnidadeCargaTrechoAudit.dtInc
                                    )
                                  }}
                                </span>
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit != null &&
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit
                                      .auditoriaFrete.docTransp != null
                                  "
                                >
                                  {{
                                    formatDate(
                                      item.pedidoUnidadeCargaTrecho
                                        .pedidoUnidadeCargaTrechoAudit
                                        .auditoriaFrete.dtConferencia
                                    )
                                  }}
                                </span>
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit != null &&
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit
                                      .auditoriaFrete.docTransp != null &&
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit
                                      .auditoriaFrete.usuarioConferencia != null
                                  "
                                >
                                  {{
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit
                                      .auditoriaFrete.usuarioConferencia.email
                                  }}
                                </span>
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit != null &&
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit
                                      .auditoriaFrete.docTransp != null
                                  "
                                >
                                  {{
                                    formatDate(
                                      item.pedidoUnidadeCargaTrecho
                                        .pedidoUnidadeCargaTrechoAudit
                                        .auditoriaFrete.dtAprovacao
                                    )
                                  }}
                                </span>
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit != null &&
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit
                                      .auditoriaFrete.docTransp != null &&
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit
                                      .auditoriaFrete.usuarioAprovacao != null
                                  "
                                >
                                  {{
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit
                                      .auditoriaFrete.usuarioAprovacao.email
                                  }}
                                </span>
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit != null &&
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit
                                      .auditoriaFrete.docTransp != null
                                  "
                                >
                                  {{
                                    formatDate(
                                      item.pedidoUnidadeCargaTrecho
                                        .pedidoUnidadeCargaTrechoAudit
                                        .auditoriaFrete.dtReprovado
                                    )
                                  }}
                                </span>
                              </td>
                              <td>
                                <span
                                  v-if="
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit != null &&
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit
                                      .auditoriaFrete.docTransp != null &&
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit
                                      .auditoriaFrete.usuarioReprovacao != null
                                  "
                                >
                                  {{
                                    item.pedidoUnidadeCargaTrecho
                                      .pedidoUnidadeCargaTrechoAudit
                                      .auditoriaFrete.usuarioReprovacao.email
                                  }}
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </section>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
      </div>
      <!--.tab-content-->
    </div>
  </div>
</template>

  <script>
import moment from "moment";
import accounting from "accounting";

export default {
  data() {
    return {
      helpForm: new Form({
        recordCollection: [],
        status: "",
        carocorren_id: "",
        lay_id: "",
        carga_id: "",
        manifesto_id: "",
        docs: [],
      }),
      cnpj_formatado: "",
      visibleDetailRows: [],
      formimprimir: new Form({
        doc_id: "",
        doc_id_pdf: [],
        doccte_id: "",
        docrps_id: "",
        tpDoc: "",
        tp_doc: "",
        tp_print: "",
      }),
    };
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  methods: {
    onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      var cnpj_formatado;
      var pad = "00000000";
      var cnpj_base =
        pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
      var pad = "0000";
      var cnpj_filial =
        pad.substring(0, pad.length - cnpj_filial.toString().length) +
        cnpj_filial;
      var pad = "00";
      var cnpj_digito =
        pad.substring(0, pad.length - cnpj_digito.toString().length) +
        cnpj_digito;

      return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
    },
    DateFormat: function (date) {
      if (date != null) {
        return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
      }
      return "";
    },
    formatDate(value, fmt = "D/MM/YYYY HH:mm") {
      return value == null ? "" : moment(value, "YYYY-MM-DD HH:mm").format(fmt);
    },
    formatDateSeconds(value, fmt = "D/MM/YYYY HH:mm:ss") {
      return value == null
        ? ""
        : moment(value, "YYYY-MM-DD HH:mm:ss").format(fmt);
    },
    onActivateDesactivate(action, data, tipo) {
      // Tipo = true = Checkbox
      this.helpForm.status = action;
      if (tipo) {
        this.helpForm.recordCollection = [];
        this.helpForm.recordCollection.push(data.unidoc_id);
      } else {
        this.helpForm.recordCollection = [];
        this.$refs.vuetable.selectedTo.forEach((obj) => {
          this.helpForm.recordCollection.push(obj);
        });
      }
      this.$refs.vinculardocumentounidadeform.onActivateDesactivate(
        this.helpForm
      );
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
    ajustaMascara(data) {
      if (data != null) {
        if (data.length == 11) {
          //cpf
          return data.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
        }
        if (data.length == 14) {
          //cnpj
          return data.replace(
            /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
            "$1.$2.$3/$4-$5"
          );
        }
      }
    },
    onExportCsv(data) {
      this.helpForm.manifesto_id = data;
      this.loading = true;
      this.isDisabled = true;
      this.helpForm
        .post("/api/exportacaodocfiscal/mdfe/chave")
        .then((response) => {
          new ReturnApi(response, this, true, false, false, false);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onImprimirMdfe(data) {
      this.helpForm.manifesto_id = [data];
      this.helpForm
        .post("/api/mdfe/imprimir")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onDownloadXmlMdfe(data) {
      this.loading = true;
      this.isDisabled = true;
      this.helpForm.manifesto_id = data;
      this.helpForm
        .post("/api/mdfe/downloadxml")
        .then((response) => {
          new ReturnApi(response, this, true, null, null, false);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onImprimirRps(data, tpDoc) {
      this.loading = true;
      this.isDisabled = true;
      this.formimprimir.doc_id = data;
      this.formimprimir.tpDoc = tpDoc;
      this.formimprimir.tp_doc = tpDoc;
      this.formimprimir
        .post("/api/cte/imprimirps")
        .then((response) => {
          new ReturnApi(response, this, true, null, null, false);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
        });
    },
    onDownloadXml(doccte_id, docrps_id) {
      this.loading = true;
      this.isDisabled = true;
      this.formimprimir.doccte_id = doccte_id;
      this.formimprimir.docrps_id = docrps_id;
      this.formimprimir
        .post("/api/cte/downloadxml")
        .then((response) => {
          new ReturnApi(response, this, true, null, null, false);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onExportNotfis(data) {
      this.loading = true;
      this.isDisabled = true;
      this.helpForm.docs.push(data);
      this.helpForm.lay_id = 84;
      this.helpForm
        .post("/api/exportacaodocfiscal/notfis")
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onRowClass(data, index) {
      return data.status.valor == 1 ? "table-warning" : "table-success";
    },
    onImprimirXml(doc_id, tp_print, tpDoc) {
      this.loading = true;
      this.isDisabled = true;
      this.formimprimir.doc_id_pdf = [];
      if (tp_print == 2 || tp_print == 3) {
        this.$refs.vuetable.selectedTo.forEach((obj) => {
          this.formimprimir.doc_id_pdf.push({
            id: obj,
          });
        });
      } else if (tp_print == 1) {
        this.formimprimir.doc_id_pdf.push({
          id: doc_id,
          tpDoc: tpDoc,
        });
      }
      this.formimprimir.tp_print = tp_print;

      this.loading = true;
      this.isDisabled = true;
      this.formimprimir
        .post("/api/cte/imprimircte")
        .then((response) => {
          new ReturnApi(response, this, true, null, null, false);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
        });
    },
    onReenvioErp(id) {
      this.loading = true;
      this.isDisabled = true;
      this.helpForm.carocorren_id = id;
      this.helpForm
        .patch("/api/inclusaoocorrencia/reenvio")
        .then((response) => {
          new ReturnApi(response, this);
          Vue.nextTick(() => this.$refs.vuetable.reload());
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onPrintRomaneio(carga_id) {
      this.loading = true;
      this.isDisabled = true;
      this.helpForm.carga_id = carga_id;
      this.helpForm
        .post("/api/expedicao/mdferomaneio")
        .then((response) => {
          new ReturnApi(response, this);
          Vue.nextTick(() => this.$refs.vuetable.reload());
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    setNomeSobrenome(data) {
      this.split = data.split(" ");
      return (
        this.split[0] +
        " " +
        (this.split[this.split.length - 1] == this.split[0]
          ? ""
          : this.split[this.split.length - 1])
      );
    },
    formatNumber(value) {
      return accounting.formatNumber(value, 2, ".", ",");
    },
    formatNumberPrecision3(value) {
      return accounting.formatNumber(value, 3);
    },
    onDetail(carocorren_id) {
      this.toggleDetail(carocorren_id);
    },
    isVisibleDetail(rowId) {
      return this.visibleDetailRows.indexOf(rowId) >= 0;
    },
    showDetail(rowId) {
      if (!this.isVisibleDetail(rowId)) {
        this.visibleDetailRows.push(rowId);
      }
    },
    hideDetail(rowId) {
      if (this.isVisibleDetail(rowId)) {
        this.visibleDetailRows.splice(this.visibleDetailRows.indexOf(rowId), 1);
      }
    },
    toggleDetail(rowId) {
      if (this.isVisibleDetail(rowId)) {
        this.hideDetail(rowId);
      } else {
        this.showDetail(rowId);
      }
    },
    goLink(data) {
      window.open(data, "_blank");
    },
    showMdfe(item) {
      return item.docCargaDoc != null &&
        item.docCargaDoc.doc != null &&
        item.docCargaDoc.doc.manifestoDoc != null &&
        item.docCargaDoc.doc.manifestoDoc.manifesto != null;
    }
  },
};
</script>
